"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrUserInteraction = getPrUserInteraction;
var Deferred_1 = require("./Deferred");
function getPrUserInteraction() {
    var d = new Deferred_1.Deferred();
    var callback = function () {
        d.resolve();
        cleanup();
    };
    var cleanup = function () {
        window.document.removeEventListener("mousemove", callback, false);
        window.document.removeEventListener("keydown", callback, false);
        window.document.removeEventListener("touchstart", callback, false);
        window.document.removeEventListener("touchend", callback, false);
    };
    window.document.addEventListener("mousemove", callback, false);
    window.document.addEventListener("keydown", callback, false);
    window.document.addEventListener("touchstart", callback, false);
    window.document.addEventListener("touchend", callback, false);
    return {
        prUserInteraction: d.pr,
        cancelPrUserInteraction: cleanup
    };
}
//# sourceMappingURL=getPrUserInteraction.js.map